import h from '../h';
export default function Grid(_ref) {
  var styles = _ref.styles,
      data = _ref.data,
      width = _ref.width,
      height = _ref.height,
      offsetY = _ref.offsetY,
      rowHeight = _ref.rowHeight,
      maxTextWidth = _ref.maxTextWidth;
  return h("g", null, data.map(function (v, i) {
    var y = (i + 1) * rowHeight + offsetY;
    return h("line", {
      key: i,
      x1: 0,
      x2: width,
      y1: y,
      y2: y,
      style: styles.line
    });
  }), h("line", {
    x1: maxTextWidth,
    x2: maxTextWidth,
    y1: 0,
    y2: height,
    style: styles.bline
  }));
}